"use client";

// Profile component
import React, { useState } from 'react';
import Image from 'next/image';
import { Avatar } from '@/components/avatar';

interface ProfileProps {
  picture: string | null;
  name: string | null;
  location: string | null;
  bio: string | null;
  isPremium: boolean;
  textColour: string;
  hexColour: string;
  headerStyle: string;
}

const Profile: React.FC<ProfileProps> = ({ picture, name, location, bio, isPremium, textColour, hexColour, headerStyle }) => {
  const [showFullBio, setShowFullBio] = useState(false);
  const altName = name + '\'s profile image' || 'profile image';
  const toggleBio = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setShowFullBio(!showFullBio);
  };

  const getBio = () => {
    if (showFullBio) {
      return bio;
    } else if (bio && bio.length > 200) {
      return bio.slice(0, 200) + '...';
    } else {
      return bio;
    }
  };

  const paddingTop = headerStyle === 'image' ? 'pt-32' : 'pt-24';
  return (
    <div className={`relative flex flex-col items-center justify-center space-y-4 px-4 pb-4 ${paddingTop}`}>
      <div className="relative bg-white rounded-full border-2 border-white shadow-xl overflow-hidden w-32 h-32">
        {picture ? (
          <Image src={picture} alt={altName} width={128} height={128} className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <Avatar name={name || ''} className="w-full h-full text-3xl" colorise />
        )}
      </div>
      <div className="flex flex-col space-y-2 items-center">
        <div className="text-center">
          <h2 className="inline text-2xl font-bold leading-snug tracking-normal" style={{ color: textColour }}>
            {name}
          </h2>
          { isPremium && (
            <Image className="inline align-middle ml-2 mb-1" src="/super-icon.svg" alt="Super tick" width={25} height={25} />
          )}
        </div>
        <p className="text-sm font-normal leading-5 text-center mx-4" style={{ color: textColour }}>
          <span role="img" aria-label="Location Pin">📍</span>
          {location}
        </p>
      </div>
      <p style={{ whiteSpace: 'pre-line', color: textColour}} className="text-sm font-normal leading-5 text-center mx-4 md:w-1/2">
        {getBio()}
        {bio && bio.length > 200 && (
          <div>
            <span
              style={{ color: hexColour}}
              className="underline leading-5 text-xs cursor-pointer"
              onClick={toggleBio}
            >
              {showFullBio ? 'Read less' : 'Read more'}
            </span>
          </div>
        )}
      </p>
    </div>
  );
};

export default Profile;


